import { render, staticRenderFns } from "./SectionApply.vue?vue&type=template&id=5c480893&"
var script = {}
import style0 from "./SectionApply.vue?vue&type=style&index=0&id=5c480893&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SectionApply.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports